module.exports = __webpack_public_path__ + "static/media/icons.0ec393c7.svg";